import { produce } from 'immer'
import { PaginationResponse } from 'src/models/pagination.models'
import {
  DELETE_EXPENSE_REPORTS_SUCCESS,
  DeleteExpenseReportsActions,
  GET_SUBMITTER_EXPENSE_REPORTS_FAILURE,
  GET_SUBMITTER_EXPENSE_REPORTS_INIT,
  GET_SUBMITTER_EXPENSE_REPORTS_LENGTH_SUCCESS,
  GET_SUBMITTER_EXPENSE_REPORTS_SUCCESS,
  GetSubmitterExpenseReportsActions,
  GetSubmitterExpenseReportsLengthActions,
  POST_CREATE_EXPENSE_REPORT_SUCCESS,
  PostCreateExpenseReportActions,
  SET_EMPTY_STATE_EXPENSE_REPORTS,
  SetEmptyStateExpenseReportsAction,
} from 'src/redux/actions/data/expenses.actions'
import {
  GET_ORGANIZATION_OUT_OF_POCKET_EXPENSES_ENABLED_FAILURE,
  GET_ORGANIZATION_OUT_OF_POCKET_EXPENSES_ENABLED_INIT,
  GET_ORGANIZATION_OUT_OF_POCKET_EXPENSES_ENABLED_SUCCESS,
  GetOrganizationOutOfPocketExpensesEnabledActions,
} from 'src/redux/actions/data/organizations.actions'

export interface ExpenseReportsFullPaginatedDataState {
  ids: string[]
  complete: boolean
  pagination?: PaginationResponse
  loading: boolean
  gettingOutOfPocketExpensesEnabled: boolean
  isEmpty: boolean
}

export const initialState: ExpenseReportsFullPaginatedDataState = {
  ids: [],
  complete: false,
  loading: false,
  gettingOutOfPocketExpensesEnabled: false,
  isEmpty: true,
}

export type Actions =
  | GetSubmitterExpenseReportsActions
  | PostCreateExpenseReportActions
  | GetOrganizationOutOfPocketExpensesEnabledActions
  | SetEmptyStateExpenseReportsAction
  | DeleteExpenseReportsActions
  | GetSubmitterExpenseReportsLengthActions

const OutOfPocketReportsYourReducer = (
  state = initialState,
  action: Actions,
): ExpenseReportsFullPaginatedDataState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_SUBMITTER_EXPENSE_REPORTS_INIT: {
        draft.loading = true
        return draft
      }

      case GET_SUBMITTER_EXPENSE_REPORTS_SUCCESS: {
        draft.ids =
          action.payload.pagination.page === 0
            ? action.payload.expenseReports.map(
                (expenseReport) => expenseReport.id,
              )
            : [
                ...draft.ids,
                ...action.payload.expenseReports.map(
                  (expenseReport) => expenseReport.id,
                ),
              ]
        draft.loading = false
        draft.pagination = action.payload.pagination
        draft.complete =
          action.payload.pagination.page >=
          action.payload.pagination.numberOfPages
        return draft
      }

      case GET_SUBMITTER_EXPENSE_REPORTS_LENGTH_SUCCESS: {
        draft.isEmpty = action.payload.expenseReports.length === 0
        return draft
      }

      case SET_EMPTY_STATE_EXPENSE_REPORTS: {
        draft.isEmpty = false
        return draft
      }

      case GET_SUBMITTER_EXPENSE_REPORTS_FAILURE: {
        draft.loading = false
        draft.complete = true
        return draft
      }

      case POST_CREATE_EXPENSE_REPORT_SUCCESS: {
        draft.ids = [action.payload.id, ...draft.ids]
        return draft
      }

      case DELETE_EXPENSE_REPORTS_SUCCESS: {
        draft.ids = draft.ids.filter(
          (id) => !action.payload.expenseReports.deleted.includes(id),
        )
        return draft
      }

      case GET_ORGANIZATION_OUT_OF_POCKET_EXPENSES_ENABLED_INIT: {
        draft.gettingOutOfPocketExpensesEnabled = true
        return draft
      }

      case GET_ORGANIZATION_OUT_OF_POCKET_EXPENSES_ENABLED_FAILURE:
      case GET_ORGANIZATION_OUT_OF_POCKET_EXPENSES_ENABLED_SUCCESS: {
        draft.gettingOutOfPocketExpensesEnabled = false
        return draft
      }
    }
  })
}

export default OutOfPocketReportsYourReducer
